import { Grid, Typography, Button, Divider } from '@mui/material'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import VerifiedIcon from "@mui/icons-material/Verified";
import img1 from "../assets/dch logooo.png";

import React from 'react'
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import {printReceipt} from "./PrintRecipt";

export default function OrderDetail() {
  const navigate = useNavigate()
  const location = useLocation()

  const fullData = location.state.data ? JSON.parse(location.state.data) : null
  let dishesArray = []

  console.log(fullData)

  if (Array.isArray(fullData?.dishes)) {
    fullData.dishes.forEach((entry) => {
      try {
        const parsed = JSON.parse(entry);
        if (Array.isArray(parsed)) {
          dishesArray = dishesArray.concat(parsed);
        }
      } catch (e) {
        console.error("Invalid dish format", e);
      }
    });
  }

  const totalPrice = dishesArray.reduce((total, item) => {
    return total + item.rate * item.quantity;
  }, 0);

  return (
      <Grid sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Grid container spacing={2} sx={{ width: 500 }}>

          <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'row' }}>
            <img src={img1} alt="Masala Grill" width={120} />
          </Grid>
          <Grid item xs={6}>
            <Button variant="outlined" sx={{ bgcolor: "#f3b419", color: "black", "&:hover": { bgcolor: "#f3b419", color: "black" }, mt: 2 }}>
              <WhatsAppIcon />Live support
            </Button>
          </Grid>

          <Divider sx={{ backgroundColor: 'black', height: '1px', width: '100%' }} />

          <Grid item xs={12}>
            <Typography sx={{ fontSize: 28, textAlign: 'left' }}>Order Details</Typography>
          </Grid>

          {dishesArray.map((item, index) => (
              <React.Fragment key={index}>
                <Grid item xs={6} sx={{ display: "flex", flexDirection: "row" }}>
                  <Typography>
                    {item.type === "full" ? "Full" : item.type === "half" ? "Half" : item.type}
                  </Typography>
                  <Typography>-{item.name} X {item.quantity}</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography>Rs:{item.rate}</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography>Rs:{item.rate * item.quantity}</Typography>
                </Grid>
              </React.Fragment>
          ))}

          <Grid item xs={12}>
            <Typography sx={{ mt: 5 }}>Total: ₹{totalPrice}</Typography>
            <Typography>SGST: ₹{(totalPrice * 2.5) / 100}</Typography>
            <Typography>CGST: ₹{(totalPrice * 2.5) / 100}</Typography>
            <Typography>Grand Total: ₹{((totalPrice * 5) / 100) + totalPrice}</Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography sx={{ display: 'flex' }}><LocalPhoneIcon /> {fullData.phone}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography sx={{ textAlign: 'left' }}>{fullData.table} #{fullData.Number}</Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography
                sx={{ display: "flex", textAlign: "end", bgcolor: 'blue', color: 'white', p: 1, borderRadius: 1 }}
            >
              {fullData.status === "served" ? (
                  <><VerifiedIcon sx={{ mr: 1 }} />Served</>
              ) : (
                  <><AccessTimeFilledIcon sx={{ mr: 1 }} />{fullData.status}</>
              )}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography sx={{ textAlign: 'left', fontSize: 23 }}>Print Invoice Now.</Typography>
            <Button
                variant="outlined"
                color="inherit"
                onClick={() =>  printReceipt(fullData)}
            >
              Print Invoice
            </Button>
          </Grid>
        </Grid>
      </Grid>
  )
}
